import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

export const AccessAndUseSection = () => {
  const t = useTranslations();
  return (
    <>
      <TypographyV3 Element="h2" variant="h3">
        {t('terms_access_title')}
      </TypographyV3>
      <TypographyV3>{t('terms_access_p_1')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_2')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_3')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_4')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_5')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_6')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_7')}</TypographyV3>
      <TypographyV3>{t('terms_access_p_8')}</TypographyV3>
    </>
  );
};
